'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsNavigatingWithKeyboard", {
    enumerable: true,
    get: function() {
        return useIsNavigatingWithKeyboard;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useKeyborgRef = require("./useKeyborgRef");
function useIsNavigatingWithKeyboard() {
    const keyborgRef = (0, _useKeyborgRef.useKeyborgRef)();
    return _react.useCallback(()=>{
        var _keyborgRef_current;
        var _keyborgRef_current_isNavigatingWithKeyboard;
        return (_keyborgRef_current_isNavigatingWithKeyboard = (_keyborgRef_current = keyborgRef.current) === null || _keyborgRef_current === void 0 ? void 0 : _keyborgRef_current.isNavigatingWithKeyboard()) !== null && _keyborgRef_current_isNavigatingWithKeyboard !== void 0 ? _keyborgRef_current_isNavigatingWithKeyboard : false;
    }, [
        keyborgRef
    ]);
}
